module.exports = __webpack_public_path__ + "img/1207677479.fb24cb93.jpg";